import { createRouter, createWebHistory } from "vue-router";
import FanControl from '@/views/fan/FanControl.vue'
import Fan3Control from '@/views/fan/Fan3Control.vue'
import Ota from '@/views/ota/OtaIndex.vue'
import IIC from '@/views/i2c/IICIndex.vue'
import Uart from '@/views/uart/UartIndex.vue'
import Gnss from '@/views/gnss/GnssIndex.vue'
import Test from '@/views/test/TestIndex.vue'
const routes = [
    { path: '/', redirect: '/home' },
    { path: '/fan', component: FanControl },
    { path: '/fan3', component: Fan3Control },
    { path: '/ota', component: Ota },
    { path: '/i2c', component: IIC },
    { path: '/uart', component: Uart },
    { path: '/gnss', component: Gnss },
    { path: '/test', component: Test }
]

const router = createRouter({
    history: createWebHistory(),
    routes, // short for `routes: routes`
})

export default router
